module.exports = __webpack_public_path__ + "media/images/default-avatar-a9c31676354e8bd05a8e0996589e9fab.png";